import React, { useMemo, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { useDispatch } from 'react-redux'
import { useSelector } from 'hooks/redux'
import {
  updateSearchString,
  requestInitialSearchResults,
  setSubmittedSearchString,
  clearSearchResults,
} from 'actions/deprecated/search'
import { getSearchResource } from 'selectors/deprecated/search'
import strings from 'utils/strings'
import { SEARCH_PAGE_SIZE } from 'utils/constants'
import {
  SearchInputField,
  SearchInfoIcon,
  SearchWrapper,
} from './SearchInput.style'

/* eslint-disable react-hooks/exhaustive-deps */
const SearchInput = ({
  className,
  resource,
  onSearch: onSearchProp,
  searchUri,
  page,
  filters,
  addToSearchRequestBody,
  tooltip,
  addOnAfter,
}) => {
  const dispatch = useDispatch()
  const startIndex = useMemo(
    () => page && (page - 1) * SEARCH_PAGE_SIZE + 1,
    [page]
  )

  const { searchString } = useSelector(getSearchResource, resource)

  const handleChange = (event) => {
    dispatch(updateSearchString(event.target.value, resource))
  }

  const handleClear = useCallback(() => {
    dispatch(updateSearchString('', resource))
    dispatch(setSubmittedSearchString('', resource))
    dispatch(clearSearchResults(resource))
  }, [resource])

  const handleSearch = useCallback(
    (config = { resetPagination: true }) => {
      const requestBody = {
        ...filters,
        ...addToSearchRequestBody,
        search: searchString,
        count: SEARCH_PAGE_SIZE,
        startIndex: config.resetPagination ? 1 : startIndex,
      }

      dispatch(
        requestInitialSearchResults(
          searchUri,
          resource,
          requestBody,
          startIndex
        )
      )
      dispatch(setSubmittedSearchString(searchString, resource))
    },
    [searchUri, searchString, resource, startIndex, filters]
  )

  useEffect(() => {
    if (page) handleSearch({ resetPagination: false })
  }, [page])

  useEffect(() => {
    if (!isEmpty(filters)) handleSearch()
  }, [filters])

  return (
    <SearchWrapper>
      <SearchInputField
        className={className}
        size="large"
        value={searchString}
        onChange={handleChange}
        onSearch={onSearchProp || (() => handleSearch())}
        onClear={searchString ? handleClear : undefined}
        placeholder={strings.enter_search_term}
        addOnAfter={addOnAfter}
      />
      {tooltip && (
        <SearchInfoIcon
          overlayClassName="autoWidth"
          topRight
          tooltip={tooltip}
        />
      )}
    </SearchWrapper>
  )
}

SearchInput.defaultProps = {
  filters: {},
  addToSearchRequestBody: {},
  addOnAfter: true,
}

SearchInput.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.string,
  onSearch: PropTypes.func,
  searchUri: PropTypes.string,
  page: PropTypes.number,
  filters: PropTypes.object,
  addToSearchRequestBody: PropTypes.object,
  tooltip: PropTypes.string,
  addOnAfter: PropTypes.bool,
}

export default SearchInput
